import PropTypes from "prop-types";
import React from "react";
import DataGrid, { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import { ExternalLink } from "components/link";
import { DownloadRecordingFile } from "pages/recording/utils";
import { TextDisplay } from "components/display-data";
import { Restricted, permissions } from "components/auth";
import {DOWNLOAD_STATUS_AVAILABLE, STATUS_PENDING} from "../../../utils/constants";

const RecordingFileData = ({ recording, recordingFile, intl }) => {
  const recordingAvailable = recording?.availableFiles[0]?.downloadAvailable && recording?.availableFiles[0]?.downloadStatus === DOWNLOAD_STATUS_AVAILABLE;
  return !recordingFile ? null : (
    <DataGrid>
      <Restricted permissions={[permissions.recording_view]}>
        {!recordingFile.downloadAvailable ? (
          <DataGridItem big>
            <TextDisplay label={intl.formatMessage({ id: "recordingFile.url" })}>
              <ExternalLink href={recordingFile.url} disabled={recordingFile.url === STATUS_PENDING}>{recordingFile.url}</ExternalLink>
            </TextDisplay>
          </DataGridItem>
        ) : null}
      </Restricted>
      <DataGridItem small>
        <TextDisplay showIfEmpty label={intl.formatMessage({ id: "common.type" })}>
          {recordingFile.type}
        </TextDisplay>
      </DataGridItem>
      <DataGridItem small>
        <TextDisplay showIfEmpty label={intl.formatMessage({ id: "recordingFile.format" })}>
          {recordingFile.format}
        </TextDisplay>
      </DataGridItem>
      <DataGridItem small>
        <TextDisplay showIfEmpty label={intl.formatMessage({ id: "recordingFile.geometry" })}>
          {recordingFile.geometry}
        </TextDisplay>
      </DataGridItem>
      <DataGridItem small>
        <TextDisplay showIfEmpty label={intl.formatMessage({ id: "recordingFile.resolution" })}>
          {recordingFile.resolution}
        </TextDisplay>
      </DataGridItem>
      <DataGridItem>
        <DownloadRecordingFile recordingFileId={recordingFile.id} recording={recording} disabled={!recordingAvailable} />
      </DataGridItem>
    </DataGrid>
  );
};

RecordingFileData.propTypes = {
  /**
   * Grabación a la que pertenece el fichero
   **/
  recording: PropTypes.object,
  /**
   * Data to represent
   **/
  recordingFile: PropTypes.object,
};

export default injectIntl(RecordingFileData);
